import { Navigate } from 'react-router-dom';
import { ReactNode } from 'react';
import { autenticacaoService } from '@/services/autenticacaoService';

interface ProtectedRouteProps {
  children: ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  // Verificar autenticação usando o serviço
  const isAuthenticated = autenticacaoService.estaAutenticado();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}
